import { CreateShopWizard } from "@/components/Onboarding/CreateShopWizard";
import { useIsNotGuest } from "@/hooks/useIsNotGuest";

export const CreateShopPage = () => {
  useIsNotGuest();

  return (
    <div className="mx-auto flex max-w-screen-md flex-col gap-2 pt-10">
      <CreateShopWizard />
    </div>
  );
};
